import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FaMoneyBill, FaTruckMoving } from "react-icons/fa";
import cn from "classnames";

import { Page } from "ui/components";

import { Schedule } from "services/action";
import { Input, Uploader } from "ui/components";

const UpdateScheduleReport = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);

  const { data } = location?.state;

  const [receipts, setReceipts] = React.useState([]);

  const $onSubmit = async (e) => {
    let payload = {
      receipts: receipts,
    };

    const req = await Dispatch(Schedule.$updateReport(data?.id, payload));
    if (req?.message === "success") {
      History.goBack();
    }
  };

  const $handleChangeReceipts = async (i, k, v) => {
    let newItems = [...receipts];

    newItems[i][k] = v;

    setReceipts(newItems);
  };

  React.useEffect(() => {
    if (!data) return

    let newReceipts = []
    data?.document?.receipts.forEach((i) => {
      let d = {
        nominal: i?.nominal,
        type: i?.type,
        images: i?.images
      }

      if (i?.type === 'start_odo') {
        d.nominal = data?.document?.start_odo
      }

      if (i?.type === 'end_odo') {
        d.nominal = data?.document?.end_odo
      }

      newReceipts.push(d)
    })

    setReceipts(newReceipts);
  }, [data])

  return (
    <Page
      title="Perbaharui Absence"
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onSubmit}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        {receipts?.map((r, k) => (
          <div key={k} className="border-bottom">
            <span className='text-capitalize fw-semibold'>{r?.type?.replace('start_odo', 'Km Awal')?.replace('end_odo', 'Km Akhir')}</span>
            <Uploader
              images={r?.images}
              errors={StateForm?.errors[`receipts.${k}.images`]}
              onChange={(e) =>
                $handleChangeReceipts(k, 'images', e)
              }
              type={`clockout_${r?.type}`}
              code={data?.id}
            />

            <div className="form-group ">
              <Input
                icon={r?.type === 'start_odo' || r?.type === 'end_odo' ? <FaTruckMoving /> : <FaMoneyBill />}
                value={r?.nominal}
                onChange={(e) =>
                  $handleChangeReceipts(k, 'nominal', e.target.valueAsNumber)
                }
                type="number"
                placeholder=""
                error={StateForm?.errors[`receipts.${k}.nominal`]}
                lg
              />
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
};

export default UpdateScheduleReport;
